import {
  Box,
  Flex,
  Avatar,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Stack,
  useColorMode,
  Center,
} from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';

import {  BrowserRouter, Route, Switch, Routes, Redirect, useNavigate , Navigate } from 'react-router-dom';

import {useDisclosure, } from "@chakra-ui/react"
import {HamburgerIcon, ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'
import { useMediaQuery } from "@chakra-ui/react"


import { useDispatch, useSelector } from 'react-redux';
import { LOGOUT } from '../../../redux/users/user_types';

import {
  DropdownMenu,
  DropdownItem,
  DropdownHeader,
  DropdownDivider,
  MenuMenu,
  Dropdown,
  Icon,
  Menu as MenuSemantic,
  MenuItem as MenuItemSemantic,
  Segment,
} from 'semantic-ui-react'

import {useState} from "react"


import { Navigation } from "../../../routes/Navigation";

export default function Navbar() {
  const { colorMode, toggleColorMode } = useColorMode();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const {auth, user, token, loading, error} = useSelector((state)=>state.userReducer)

  const { isOpen, onOpen, onClose } = useDisclosure()

  
  const [isMobile] = useMediaQuery("(max-width: 768px)") 

  return (
    <>
        

      <Box zIndex={"9999"} top = {0} 
            position = {"fixed"} w = {"100%"} boxShadow = {"rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;"}
            // bg={"#5b9cf2"} 
            bg={"#3077d5"}
            px={4}>
        
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <Box fontWeight={"bold"} cursor="pointer" onClick={()=>{nav("/")}}>pNotas
          
          {isMobile ?               
                  <Dropdown>
                    <DropdownMenu>          
                      <DropdownItem onClick={()=>{nav("/notes")}}>Notas</DropdownItem>
                      <DropdownItem onClick={()=>{nav("/destinos")}}>Destinos</DropdownItem>
                      <DropdownItem onClick={()=>{nav("/estados")}}>Estados</DropdownItem>
                      <DropdownDivider />          
                      <DropdownItem onClick={()=>{dispatch({type: LOGOUT})}}>Logout</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>                
            : ''}

          </Box>

          {isMobile ? ''  : <>
              <Flex alignItems={'center'}>
              
                <Stack alignItems = {"center"} direction={'row'} spacing={7}>

                
                  
                  <Button display={auth?"block":"none"} bg={"#737878"} onClick={()=>{nav("/notes")}}>Todas las notas</Button>

                  <Button display={auth?"block":"none"} bg={"#737878"} onClick={()=>{nav("/destinos")}}>Destinos</Button>
                  <Button display={auth?"block":"none"} bg={"#737878"} onClick={()=>{nav("/estados")}}>Estados</Button>
                  
                  <Button display={auth?"none":"block"} bg={"#737878"} onClick={()=>{nav("/login")}}>Iniciar Sesión</Button>
                  <Button display={auth?"none":"block"} bg={"#737878"} onClick={()=>{nav("/register")}}>Registrarse</Button>
                  {/* <Button bg = {"#01d8fb"} onClick={toggleColorMode}> {colorMode === 'light' ? <MoonIcon /> : <SunIcon />} </Button> */}

                  <Menu>
                    <MenuButton display={auth?"block":"none"}
                      as={Button}
                      border = "2px solid #5b9cf2"
                      padding = {2}
                      rounded={'full'}
                      variant={'link'}
                      cursor={'pointer'}
                      minW={0}>
                      <Avatar
                        size={'sm'}
                        src={"/user3.png"}
                      />
                    </MenuButton>
                    <MenuList alignItems={'center'}>
                      <br />
                      <Center>
                        <Avatar
                          size={'lg'}
                          src={'/user3.png'}
                        />
                      </Center>
                      <br />
                      <Center>
                        <p>{user}</p>
                      </Center>
                      <br />
                      <MenuDivider />
                      <MenuItem onClick={()=>{
                        dispatch({type: LOGOUT})
                        }}>Logout</MenuItem>
                    </MenuList>
                  </Menu>
                </Stack>
              </Flex>
              </>}
        </Flex>
      </Box>
    </>
  );
}